import { render, staticRenderFns } from "./MemberManagement.vue?vue&type=template&id=2f89acb3&scoped=true&"
import script from "./MemberManagement.vue?vue&type=script&lang=js&"
export * from "./MemberManagement.vue?vue&type=script&lang=js&"
import style0 from "./MemberManagement.vue?vue&type=style&index=0&id=2f89acb3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f89acb3",
  null
  
)

export default component.exports